import { render, staticRenderFns } from "./AuxiliaryRegisterDetails.vue?vue&type=template&id=176437d6&"
import script from "./AuxiliaryRegisterDetails.vue?vue&type=script&lang=js&"
export * from "./AuxiliaryRegisterDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports